var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-table", {
    attrs: {
      fields: _vm.fields,
      items: _vm.items,
      "table-class": "text-nowrap",
      responsive: "",
      hover: "",
    },
    on: { "row-clicked": _vm.onClickRow },
    scopedSlots: _vm._u([
      {
        key: "cell(title)",
        fn: function (data) {
          return [
            _c(
              "h4",
              { staticClass: "mb-0" },
              [
                data.item.listing.is_promoted
                  ? _c("b-icon-star-fill", {
                      attrs: { title: "Featured Listing" },
                    })
                  : _vm._e(),
                _vm._v("\n      " + _vm._s(data.item.title) + "\n    "),
              ],
              1
            ),
          ]
        },
      },
      {
        key: "cell(bids)",
        fn: function (data) {
          return [
            _vm._v(
              "\n    Current Bid: " + _vm._s(data.item.current_bid) + "\n    "
            ),
            _c("br"),
            _vm._v(
              "\n    Total Bids: " +
                _vm._s(data.item.listing.bids_count) +
                "\n  "
            ),
          ]
        },
      },
      {
        key: "cell(status)",
        fn: function (data) {
          return [
            _c("admin-listing-status-badge", {
              attrs: { listing: data.item.listing },
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }